// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages90_root__2Dznv","title":"AfterImages90_title__33r1A","images":"AfterImages90_images__3acOf"};